module.exports = __webpack_public_path__ + "static/img/01.0a61e07.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/news/01.png
// module id = pH//
// module chunks = 1